import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <div id="pricing" className="bg-stone-900 py-24 px-4 sm:px-6 lg:px-8 text-white relative overflow-hidden" data-id="element-113">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-rose-900/20 rounded-full blur-3xl" data-id="element-114"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-stone-800/50 rounded-full blur-3xl" data-id="element-115"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-116">
        <Section data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-118">
            Recupera tu paz por menos de lo que cuesta un delivery
          </h2>
          <p className="text-stone-400 text-lg mb-12 max-w-2xl mx-auto" data-id="element-119">
            No quiero que lo pienses una semana. Quiero que sea una decisión
            fácil para que empieces hoy mismo.
          </p>

          <div className="bg-white text-stone-900 rounded-3xl p-8 md:p-12 max-w-lg mx-auto shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-120">
            <div className="text-center mb-8" data-id="element-121">
              <span className="text-sm font-bold tracking-wider text-rose-500 uppercase" data-id="element-122">
                Oferta Especial
              </span>
              <div className="flex justify-center items-baseline mt-2" data-id="element-123">
                <span className="text-5xl font-bold tracking-tight text-stone-900" data-id="element-124">
                  $6.39
                </span>
                <span className="ml-1 text-xl font-semibold text-stone-500" data-id="element-125">
                  USD
                </span>
              </div>
              <p className="mt-4 text-stone-500 text-sm" data-id="element-126">
                Pago único. Acceso inmediato.
              </p>
            </div>

            <ul className="space-y-4 mb-10 text-left" data-id="element-127">
              {['Guía completa Reset Hormonal 14 Días', 'Sistema de Semáforo Hormonal', 'Plantillas de comidas rápidas', "Herramienta 'Escalera del Antojo'", 'Guía de supervivencia social'].map((item, i) => <li key={i} className="flex items-center" data-id="element-128">
                  <div className="bg-green-100 rounded-full p-1 mr-3" data-id="element-129">
                    <Check className="w-4 h-4 text-green-600" data-id="element-130" />
                  </div>
                  <span className="text-stone-700" data-id="element-131">{item}</span>
                </li>)}
            </ul>

            <Button fullWidth className="text-lg py-5 shadow-rose-500/30 shadow-lg" data-id="element-132">
              Quiero el Reset Hormonal 14 Días
            </Button>

            <p className="mt-6 text-xs text-stone-400" data-id="element-133">
              Garantía de satisfacción. Compra 100% segura.
            </p>
          </div>
        </Section>
      </div>
    </div>;
}